// extracted by mini-css-extract-plugin
export default {"avatars":"CustomOverlapImg_avatars__umiQa","avatar":"CustomOverlapImg_avatar__oGYyL"};